import {connect} from "react-redux";
import Chat from "../../components/Chat/Chat";
import * as ChatActions from '../../store/actions/chatActions';
import * as VideoActions from '../../store/actions/videoActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.chat,
    ...state.courses,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    addMessage: (message) => {
        dispatch(ChatActions.addMessage(message));
    },
    initChat: (profileId, token) => {
        dispatch(ChatActions.getUsers(profileId, token));
        //dispatch(ChatActions.getThreads(profileId, token));
    },
    createLog: (log, token) => {
        dispatch(VideoActions.createLog(log, token));
    },
    updateLog: (log, token) => {
        dispatch(VideoActions.updateLog(log, token));
    },
    threadCreated: (thread) => {
        dispatch(ChatActions.threadCreated(thread));
    },
    getChatLectures: (subjectId, token) => {
        dispatch(ChatActions.getChatLecures(subjectId, token));
    },
    setIsTyping: (data) => {
        dispatch(ChatActions.setIsTyping(data));
    },
    setSeen: (data) => {
        dispatch(ChatActions.setSeen(data));
    },
    setInitialThreads: (threads) => {
        dispatch(ChatActions.setInitialThreads(threads));
    },
    uploadMessageFiles: (files, profileId, token) => {
        dispatch(ChatActions.uploadMessageFiles(files, profileId, token));
    },
    cancelMessageFile: (file, profileId, token) => {
        dispatch(ChatActions.cancelMessageFile(file, profileId, token));
    },
    clearMessageFiles: () => {
        dispatch(ChatActions.clearMessageFiles());
    },
    getSettings: () => {
        dispatch(ChatActions.getSettings());
    },
    setSidebarTab: (tab) => {
        dispatch(ChatActions.setSidebarTab(tab));
    },
    messengerSearch: (term, token) => {
        dispatch(ChatActions.messengerSearch(term, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Chat);


// WEBPACK FOOTER //
// ./src/containers/Chat/ChatContainer.js